import { SVGAttributes } from 'react';

export const AlertSprite = (props?: SVGAttributes<SVGGElement>) => (
  <>
    <defs>
      <linearGradient
        id="alert-gradient"
        x1="35.37"
        x2="-6.25"
        y1="71.94"
        y2="-1.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ff0" />
        <stop offset="1" stopColor="red" />
      </linearGradient>
    </defs>
    <g {...props}>
      <path
        fill="url(#alert-gradient)"
        d="M3.91 64.5L3.91 48.09 5.07 48.09 2.62 2.5 23.38 2.5 20.93 48.09 22.09 48.09 22.09 64.5 3.91 64.5z"
      />
      <path d="M20.76 5l-2.31 42.9H7.55L5.24 5h15.52M19.6 50.59V62H6.4V50.59h13.2M26 0H0l.28 5.28 2.17 40.3h-1V67h23.12V45.58h-1l2.17-40.3L26 0z" />
    </g>
  </>
);
